// extracted by mini-css-extract-plugin
export var label = "_j9-2";
export var slideContainer = "_j9-0";
export var slider = "_j9-1";